import React, { ReactNode, useEffect, useRef } from 'react';

import './styles.scss';

interface Props {
    children: ReactNode;
    text: ReactNode;
    className?: string;
    align?: 'left' | 'center' | 'right';
    theme?: 'default' | 'dark';
    showArrow?: boolean;
}

export const HoverTooltip = ({
    children,
    text,
    align = 'center',
    className = '',
    theme = 'default',
    showArrow = false,
}: Props) => {
    const tooltipRef = useRef<HTMLDivElement>(null);
    const tooltipButtonRef = useRef<HTMLDivElement>(null);
    const tooltipArrowRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (tooltipRef && tooltipRef.current && tooltipButtonRef && tooltipButtonRef.current) {
            const tooltipWidth = tooltipRef.current.offsetWidth;
            const tooltipButtonWidth = tooltipButtonRef.current.offsetWidth;
            const tooltipButtonHeight = tooltipButtonRef.current.offsetHeight;
            tooltipRef.current.style.bottom = `calc(${tooltipButtonHeight}px + 4px)`;

            switch (align) {
                case 'left':
                    tooltipRef.current.style.left = '0px';
                    if (theme === 'dark' && tooltipArrowRef && tooltipArrowRef.current) {
                        tooltipArrowRef.current.style.left = '8px';
                    }
                    break;
                case 'right':
                    tooltipRef.current.style.right = '0px';
                    if (theme === 'dark' && tooltipArrowRef && tooltipArrowRef.current) {
                        tooltipArrowRef.current.style.right = '8px';
                    }
                    break;
                case 'center':
                default:
                    tooltipRef.current.style.left = `calc(-1 * ((${tooltipWidth}px - ${tooltipButtonWidth}px) / 2))`;
                    if (theme === 'dark' && tooltipArrowRef && tooltipArrowRef.current) {
                        const tooltipArrowWidth = tooltipArrowRef.current.offsetWidth;
                        tooltipArrowRef.current.style.left = `calc((${tooltipWidth}px - ${tooltipArrowWidth}px) / 2)`;
                    }
                    break;
            }
        }
    }, [tooltipRef, tooltipButtonRef, tooltipArrowRef, align, theme]);

    return (
        <div className={`app-hover-tooltip ${className}`}>
            <div
                className={`app-hover-tooltip__text ${theme === 'dark' ? 'app-hover-tooltip__text--dark' : ''}`}
                ref={tooltipRef}
            >
                {showArrow && (
                    <span
                        className={`app-hover-tooltip__arrow ${
                            theme === 'dark' ? 'app-hover-tooltip__arrow--dark' : ''
                        }`}
                        ref={tooltipArrowRef}
                    ></span>
                )}
                {text}
            </div>
            <div className='app-hover-tooltip__button-wrap' ref={tooltipButtonRef}>
                {children}
            </div>
        </div>
    );
};
